import { render, staticRenderFns } from "./Linkage.vue?vue&type=template&id=7532f0ac&scoped=true"
import script from "./Linkage.vue?vue&type=script&lang=js"
export * from "./Linkage.vue?vue&type=script&lang=js"
import style0 from "./Linkage.vue?vue&type=style&index=0&id=7532f0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532f0ac",
  null
  
)

export default component.exports